const jobPositionsSettingsLinks: any[] = [
  {
    label: "JOB_CATEGORIES",
    capability: "show_menu_categories_job_positions_list",
    url: "/dashboard/job-positions-categories",
    section: "lists", // lists, update_data, administration, documents, notifications, manage_platform, user_permissions
  },
];

export default jobPositionsSettingsLinks;
